export const TemplateTypes = {
    API: 'api',
    Servico: 'servico',
    Aplicacao: 'aplicacao',
    Credencial: 'credencial',
    Outros: 'outros'
} as const;


export type TemplateType = (typeof TemplateTypes)[keyof typeof TemplateTypes];

const TemplateTypesValues = Object.values(TemplateTypes);

export function getTemplateType(rawType: string): TemplateType {
    if (rawType && TemplateTypesValues.includes(rawType as any)) {
        return rawType as TemplateType;
    }
    
    return TemplateTypes.Outros;
}